import React from 'react';
import { useParams } from 'react-router-dom';
import AgencyHeader from '../../components/headers/AgencyHeader';
import InsuranceUploadContent from '../../components/InsuranceUploadContent';
import { useInsuranceUpload } from '../../hooks/useInsuranceUpload';
import '../../styles/Tabs.css';
import '../../styles/AgencyRegistration.css';
import '../../styles/InsuranceUpload.css';
import '../../styles/PopUp.css';

// 申請アップロードページコンポーネント（代理店向け）
// ※pages/adminにも同様のコンポーネントがあるため、修正時は同時に確認すること
const InsuranceUpload = () => {
  const { agencyId } = useParams();
  
  // カスタムフックを使用して共通処理を取得
  const insuranceUploadProps = useInsuranceUpload(agencyId);

  return (
    <>
      <AgencyHeader />
      <InsuranceUploadContent {...insuranceUploadProps} />
    </>
  );
};

export default InsuranceUpload;